import { i18n } from '@/lang';
import { router } from '@/router';
import { store } from '@/store';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import App from '@js/App';
import SvgSprite from 'vue-svg-sprite';
import Vue from 'vue';
import VueGtm from 'vue-gtm';

import '@/filters';
import '@sass/app.scss';

// Google Tag Manager
Vue.use(VueGtm, {
    id: process.env.VUE_APP_GOOGLE_TRACKING_ID,
    vueRouter: router,
});

// Recaptcha
Vue.use(VueReCaptcha, {
    siteKey: process.env.VUE_APP_RECAPTCHA_KEY,
    loaderOptions: {
        autoHideBadge: true,
        explicitRenderParameters: {
            badge: 'bottomleft',
        },
    },
});

// SVG Sprite
Vue.use(SvgSprite, {
    url: require('./svg/sprites.svg'),
    class: 'icon',
});

// Vue config
Vue.config.devtools = true;
Vue.config.productionTip = false;
Vue.config.silent = false;

// Global components
Vue.component('v-alert', require('@cmp/Alert').default);
Vue.component('v-arrow', require('@cmp/Arrow').default);
Vue.component('v-banner', require('@cmp/Banner').default);
Vue.component('v-button', require('@cmp/forms/Button').default);
Vue.component('v-button-google', require('@cmp/forms/ButtonGoogle').default);
Vue.component('v-capability', require('@cmp/Capability').default);
Vue.component('v-claims', require('@cmp/Claims').default);
Vue.component('v-close', require('@cmp/Close').default);
Vue.component('v-dropdown', require('@cmp/Dropdown').default);
Vue.component('v-form-group', require('@cmp/forms/FormGroup').default);
Vue.component('v-google-one-tap', require('@cmp/GoogleOneTap').default);
Vue.component('v-hero', require('@cmp/Hero').default);
Vue.component('v-icon', require('@cmp/Icon').default);
Vue.component('v-input', require('@cmp/forms/Input').default);
Vue.component('v-section', require('@sections/Section').default);
Vue.component('v-section-bullets', require('@sections/SectionBullets').default);
Vue.component('v-section-campaigns', require('@sections/SectionCampaigns').default);
Vue.component('v-section-compare-price', require('@sections/SectionComparePrice').default);
Vue.component('v-section-contact', require('@sections/SectionContact').default);
Vue.component('v-section-clients', require('@sections/SectionClients').default);
Vue.component('v-section-features', require('@sections/SectionFeatures').default);
Vue.component('v-section-install', require('@sections/SectionInstall').default);
Vue.component('v-section-integrations', require('@sections/SectionIntegrations').default);
Vue.component('v-section-key-features', require('@sections/SectionKeyFeatures').default);
Vue.component('v-section-reviews', require('@sections/SectionReviews').default);
Vue.component('v-section-signoff', require('@sections/SectionSignoff').default);
Vue.component('v-section-testimonials', require('@sections/SectionTestimonials').default);
Vue.component('v-signup', require('@cmp/Signup').default);
Vue.component('v-loader', require('@cmp/Loader').default);
Vue.component('v-switch', require('@cmp/forms/Switch').default);
Vue.component('v-textarea', require('@cmp/forms/Textarea').default);

// App
new Vue({ i18n, router, store, render: h => h(App) }).$mount('#app');
